import usePageMeta from "../../hooks/usePageMeta";

export default function LegalLayout({
  title,
  eyebrow = "Legal",
  path,
  description,
  children,
}) {
  usePageMeta({
    title,
    description:
      description ||
      `${title} for Queen Cleopatra's erotic hypnosis practice. Adults 18+.`,
    path,
  });
  return (
    <div data-testid={`legal-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <section className="py-24 md:py-32 max-w-4xl mx-auto px-6 md:px-10">
        <div className="eyebrow mb-5">{eyebrow}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-cream leading-[1.05] mb-10">{title}</h1>
        <div className="prose-legal text-cream/75 leading-relaxed space-y-5 text-[15px]">
          {children}
        </div>
      </section>
    </div>
  );
}
